/**
 * Shared helpers for application-form validation.
 *
 * The admission forms mark required fields with MUI's `required` prop (which
 * renders the asterisk) and use `getRequiredFieldsMessage` when the user hits
 * Next so they get a clear, specific message instead of a generic error.
 */

export function isBlank(value) {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === "string") {
    return value.trim() === "";
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  return false;
}

/**
 * @param {Array<{ label: string, value: unknown }>} fields
 * @returns {string[]} labels for every field that has not been filled in
 */
export function getMissingFieldLabels(fields) {
  return fields
    .filter(({ value }) => isBlank(value))
    .map(({ label }) => label);
}

/**
 * Builds the message shown when the user tries to proceed with an incomplete
 * step. Returns an empty string when every field is filled.
 *
 * @param {Array<{ label: string, value: unknown }>} fields
 * @returns {string}
 */
export function getRequiredFieldsMessage(fields) {
  const missing = getMissingFieldLabels(fields);

  if (!missing.length) {
    return "";
  }

  const noun = missing.length === 1 ? "field" : "fields";

  return `Please fill in the required ${noun} before proceeding: ${missing.join(
    ", "
  )}.`;
}
